import { useQuery } from '@tanstack/react-query'

import { IInstitutionsService } from '@/services/contracts/institutions'
import { useFormatOptions } from '../../../../../hooks/use-format-options'
import { Institution } from '@/domain/entities/institution.entity'

type ListInstitutionsProps = {
  institutionsService: IInstitutionsService
}

export function useListInstitutions({
  institutionsService,
}: ListInstitutionsProps) {
  const { formatOptions } = useFormatOptions()

  const {
    data,
    error: institutionsError,
    isPending: isLoadingInstitutions,
  } = useQuery({
    queryKey: ['list_institutions'],
    initialData: [null, null],
    queryFn: institutionsService.loadAll,
  })

  const [response, error] = data
  const institutionOptions = formatOptions<Institution>(
    response?.institutions,
    'titulo',
  )

  return {
    institutionOptions,
    institutions: response?.institutions,
    institutionsError: error || institutionsError,
    isLoadingInstitutions,
  }
}
